(function ($) {
  $('.notify-me').click(function (e) {
    e.preventDefault();
    var skuBaseId = $(this).attr('data-sku-id');
    var file = '/waitlist/signup.tmpl?SKU_BASE_ID=' + skuBaseId + '&REQUEST_TYPE=BIS';
    var options = {
      includeBackground: false,
      includeCloseLink: true,
      hideOnClickOutside: true,
      cssStyle: {
        border: '1px solid #5dba98',
        width: 'auto',
        height: 'auto',
        padding: '0'
      }
    };

    options.content =
      '<iframe  width="580px" height="300px" scrolling="yes" frameborder="0" src="' +
      file +
      '"></iframe>';
    generic.overlay.launch(options);
  });
})(jQuery);
